import { TApplicationState } from 'shared/types/redux';

export const selectAddressErrorMessage = (state: TApplicationState): string | undefined => {
  return state.address.errorMessage;
};
